// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Gender } from './gender.js';
import type { PatientSharedAddressModel } from './patientSharedAddressModel.js';
import type { PatientSharedEmailAddressModel } from './patientSharedEmailAddressModel.js';
import type { PatientSharedPhoneModel } from './patientSharedPhoneModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientModel {
    'patientId'?: string;
    'firstName'?: string;
    'middleName'?: string;
    'lastName'?: string;
    'suffix'?: string;
    'nickname'?: string;
    'dateOfBirth'?: Moment;
    'gender'?: Gender;
    'primaryLanguageId'?: number;
    'isUsResident'?: boolean;
    'householdSize'?: number;
    'masterPatientId'?: string;
    'isDuplicate'?: boolean;
    'isTest'?: boolean;
    'isPlaceholder'?: boolean;
    'addresses'?: Array<PatientSharedAddressModel>;
    'emailAddresses'?: Array<PatientSharedEmailAddressModel>;
    'phoneNumbers'?: Array<PatientSharedPhoneModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientModel>> = [
        {
            "name":     "patientId",
            "baseName": "patientId",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "nickname",
            "baseName": "nickname",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "Gender"
        },
        {
            "name":     "primaryLanguageId",
            "baseName": "primaryLanguageId",
            "type":     "number"
        },
        {
            "name":     "isUsResident",
            "baseName": "isUsResident",
            "type":     "boolean"
        },
        {
            "name":     "householdSize",
            "baseName": "householdSize",
            "type":     "number"
        },
        {
            "name":     "masterPatientId",
            "baseName": "masterPatientId",
            "type":     "string"
        },
        {
            "name":     "isDuplicate",
            "baseName": "isDuplicate",
            "type":     "boolean"
        },
        {
            "name":     "isTest",
            "baseName": "isTest",
            "type":     "boolean"
        },
        {
            "name":     "isPlaceholder",
            "baseName": "isPlaceholder",
            "type":     "boolean"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<PatientSharedAddressModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<PatientSharedEmailAddressModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<PatientSharedPhoneModel>"
        },
    ];

    static getAttributeTypeMap() {
        return PatientModel.attributeTypeMap;
    }
}
